
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./SigninWidget.scss";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import Home from '../pages/Home';
import Login from "./Login";

const SigninWidget = () => {


  return (
    <>
  
    <AuthenticatedTemplate>
      <Home/>
    </AuthenticatedTemplate>

    <UnauthenticatedTemplate>
        <Login/>
    </UnauthenticatedTemplate>

    </>
  );
};

export default SigninWidget;